const NairaSvg = () => {
    return (<span>₦</span>);
}

export default NairaSvg;